import React, { useCallback, useEffect, useState } from 'react';
import Button from '../../components/button';
import Header from '../../components/header';
import { useTranslation } from 'react-i18next';
import styles from './receipt.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { getDocumentPdf } from '../../api/documentApi';
import Spinner from '../../components/spinner';
import NoData from '../../components/no-data';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const ReceiptPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { documentId } = useParams();
  const [pdf, setPdf] = useState<Blob>();
  const [numPages, setNumPages] = useState<number | null>(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const getPdf = useCallback(async (docId: string) => {
    const file = await getDocumentPdf(docId);
    setPdf(file);
  }, []);

  useEffect(() => {
    if (!documentId) {
      navigate('/failed');
      return;
    }

    getPdf(documentId).catch(() => navigate('/failed'));

    const handleWindowResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [getPdf, documentId, navigate]);

  return (
    <div>
      {!pdf && <Spinner fullPage={true} />}
      <Header />
      {pdf && (
        <div className="container">
          <div className={styles.receipt}>
            <Document
              file={pdf}
              noData={<NoData />}
              loading={<Spinner fullPage={true} />}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            >
              {Array.from({ length: numPages ?? 0 }, (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  width={windowWidth - 40}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              ))}
            </Document>
          </div>
          <div className={styles.buttons}>
            <Button onClick={() => navigate(`/sign/${documentId}`)}>{t('sign_it')}</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceiptPage;
